import { IApplicationState } from '../../types/redux';

const EMPTY_MARKED_LIST: never[] = [];

export const getMarkedList = (state: IApplicationState) => state.developerV2?.seo?.markedList || EMPTY_MARKED_LIST;
